import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Hidden,
  Drawer,
  Divider,
} from "@material-ui/core";
import * as React from "react";
import ProfileHeadComponent from "./ProfileHeadComponent";
const drawerWidth = 340;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    drawer: {
      [theme.breakpoints.up("sm")]: {
        width: drawerWidth,
        flexShrink: 0,
      },
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  });
interface Props extends WithStyles<typeof styles> {
  profileData: any;
  companies: any;
  onHelperClicked: any;
  company?: any;
}
class DrawerComponent extends React.Component<Props> {
  state = { mobileOpen: false };
  public responsiveDrawer = () => {
    const { classes, profileData, companies, company, onHelperClicked } = this.props;
    return (
      <div>
        <div className={classes.toolbar}></div>
        <Divider />
        <ProfileHeadComponent
          onHelperClicked={onHelperClicked}
          profileData={profileData}
          companies={companies}
          company={company}
        />
      </div>
    );
  };
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: true });
  };
  render() {
    const { classes } = this.props;
    return (
      <nav className={classes.drawer} aria-label="mailbox folders">
        <Hidden smUp implementation="css">
          <Drawer
            variant="temporary"
            anchor={"left"}
            open={this.state.mobileOpen}
            onClose={() => this.handleDrawerToggle()}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {this.responsiveDrawer()}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {this.responsiveDrawer()}
          </Drawer>
        </Hidden>
      </nav>
    );
  }
}
export default withStyles(styles)(DrawerComponent);
